import Smtps from './components/Smtps';
export default Smtps;